import { SelectListItem, Tooltip } from 'kui';
import * as React from 'react';
import { escape } from 'underscore';
import { LIST_LABEL } from 'app/const';
import { ISearchedCard } from './types';
import './_SearchedCard.scss';
import { TB_PORTAL } from '../../../constants';

export function SearchedCard ({
    className,
    img,
    text,
    textSub,
    value,
    parentValue = '',
}: ISearchedCard) {
    const classItem = 'top-bar__filter-item';
    const classText = 'top-bar__filter-item-text';
    const classSub = 'top-bar__filter-item-sub';
    const classTooltip = classItem + '-tooltip';

    return (
        <SelectListItem
            className={`
                ${className}
                ${classItem}
                handle-click-ignore
            `}
            key={parentValue + value}
            icon={img}
            listLabel={LIST_LABEL + textSub}
            value={value}
        >
            <Tooltip
                className={classTooltip}
                value={escape(textSub)}
                portalId={TB_PORTAL}
                isPortal
            >
                <span className={classSub}>{textSub}</span>
            </Tooltip>
            <Tooltip
                className={classTooltip}
                value={escape(text)}
                portalId={TB_PORTAL}
                isPortal
            >
                <span className={classText}>{text}</span>
            </Tooltip>
        </SelectListItem>
    );
}
